import {AppState} from '../index';
import {UserMilestoneResponse} from '../../services/UserMilestoneAPI/types';

interface State {
  status: null | UserMilestoneResponse;
  isLoading: boolean;
  isLoaded: boolean;
}

const initState: State = {
  status: null,
  isLoading: false,
  isLoaded: false,
};

const FETCH_MILESTONE_START = '@milestone/fetch-start';
const FETCH_MILESTONE_SUCCESS = '@milestone/fetch-success';
const FETCH_MILESTONE_FAIL = '@milestone/fetch-fail';
const RESET_MILESTONE = '@milestone/reset';

interface FetchMilestoneStart {
  type: typeof FETCH_MILESTONE_START;
}

interface FetchMilestoneSuccess {
  type: typeof FETCH_MILESTONE_SUCCESS;
  data: UserMilestoneResponse;
}

interface FetchMilestoneFail {
  type: typeof FETCH_MILESTONE_FAIL;
}

interface ResetMilestone {
  type: typeof RESET_MILESTONE;
}

export type MilestoneAction =
  FetchMilestoneStart | FetchMilestoneSuccess | FetchMilestoneFail | ResetMilestone;

export const milestoneReducer = (
  state: State = initState,
  action: MilestoneAction,
): State => {
  switch (action.type) {
    case FETCH_MILESTONE_START:
      return {
        ...state,
        isLoading: true,
      };

    case FETCH_MILESTONE_SUCCESS:
      return {
        status: action.data,
        isLoading: false,
        isLoaded: true,
      };

    case FETCH_MILESTONE_FAIL:
      return {
        status: null,
        isLoading: false,
        isLoaded: false,
      };

    case RESET_MILESTONE:
      return {
        ...state,
        isLoaded: false,
      };

    default:
      return state;
  }
};

export const fetchMilestoneStart = (): FetchMilestoneStart => ({
  type: FETCH_MILESTONE_START,
});

export const fetchMilestoneSuccess = (data: UserMilestoneResponse): FetchMilestoneSuccess => ({
  type: FETCH_MILESTONE_SUCCESS,
  data,
});

export const fetchMilestoneFail = (): FetchMilestoneFail => ({
  type: FETCH_MILESTONE_FAIL,
});

// Marks cached status as stale: it stays visible, but the next useMilestoneStatus mount refetches it
export const resetMilestone = (): ResetMilestone => ({
  type: RESET_MILESTONE,
});

export const getMilestoneState = (state: AppState) => state.milestone;
